import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "./heavyTable.css";

const PaginationButton = ({ isSelected, label, onChangePage, active, url }) => {
  return (
    <button
      type="button"
      className={`simcc-pagination__page${isSelected ? " simcc-pagination__page--active" : ""}${
        !url ? " simcc-pagination__page--gap" : ""
      }`}
      aria-current={isSelected ? "page" : undefined}
      onClick={() => url && !active && onChangePage(label)}
    >
      {label}
    </button>
  );
};
export default function EnhancedPagination({
  list,
  rowsPerPage,
  onChangePage,
  title,
  leftSlot,
}) {
  if (rowsPerPage >= 1) {
    const pageChange = (url) =>
      onChangePage(url.substring(url.indexOf("?") + 6));
    let links = Array.isArray(list.links) ? list.links : list?.meta?.links;
    return (
      <div className="simcc-pagination">
        {leftSlot}
        <div className="simcc-pagination__pages">
          {links &&
            links.map(({ url, label, active }, i) => {
              if (label.includes("Previous")) {
                return (
                  <button
                    type="button"
                    key={i}
                    className="simcc-pagination__page"
                    aria-label="Previous page"
                    disabled={!url}
                    onClick={() => pageChange(url)}
                  >
                    <NavigateBeforeIcon fontSize="small" />
                  </button>
                );
              } else if (label.includes("Next")) {
                return (
                  <button
                    type="button"
                    key={i}
                    className="simcc-pagination__page"
                    aria-label="Next page"
                    disabled={!url}
                    onClick={() => pageChange(url)}
                  >
                    <NavigateNextIcon fontSize="small" />
                  </button>
                );
              } else {
                return (
                  <PaginationButton
                    key={i}
                    isSelected={active}
                    label={label}
                    onChangePage={onChangePage}
                    active={active}
                    url={url}
                  />
                );
              }
            })}
        </div>
      </div>
    );
  }
  return null;
}
